import type { FoundResponse } from '@wilson/shared'

export interface StoredClaim {
  claimId: string
  handoffVersion: number
  token: string
  savedAt: string
}

const key = (bottleId: string) => `wilson.finderClaim.${bottleId}`

export function saveClaim(bottleId: string, claim: FoundResponse | StoredClaim) {
  localStorage.setItem(
    key(bottleId),
    JSON.stringify({
      claimId: claim.claimId,
      handoffVersion: claim.handoffVersion,
      token: claim.token,
      savedAt: 'savedAt' in claim ? claim.savedAt : new Date().toISOString(),
    } satisfies StoredClaim),
  )
}

export function getClaim(bottleId: string): StoredClaim | null {
  try {
    const raw = localStorage.getItem(key(bottleId))
    return raw ? (JSON.parse(raw) as StoredClaim) : null
  } catch {
    return null
  }
}

export function removeClaim(bottleId: string) {
  localStorage.removeItem(key(bottleId))
}

export function acceptRecoveryFragment(bottleId: string): StoredClaim | null {
  const token = new URLSearchParams(window.location.hash.slice(1)).get('token')
  if (!token) return getClaim(bottleId)
  const existing = getClaim(bottleId)
  const claim: StoredClaim = {
    claimId: existing?.claimId ?? 'recovered',
    handoffVersion: existing?.handoffVersion ?? 0,
    token,
    savedAt: new Date().toISOString(),
  }
  saveClaim(bottleId, claim)
  window.history.replaceState(null, '', window.location.pathname + window.location.search)
  return claim
}

export function recoveryLink(bottleId: string, token: string) {
  return `${window.location.origin}/b/${bottleId}/rehide#token=${encodeURIComponent(token)}`
}
